exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ghelpaxfF0e8qI3Dw-5B1_0{font-family:ueicon;font-style:normal;line-height:1;display:-webkit-box;display:-webkit-flex;display:flex;width:1em;height:1em;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center}", ""]);

// exports
exports.locals = {
	"icon": "ghelpaxfF0e8qI3Dw-5B1_0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c71e78e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/newHome/UeIcon.vue
// module id = zzyC
// module chunks = 44